



































import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator';
import Util from '../../../lib/util'
import AbpBase from '../../../lib/abpbase'
import ChannelList from '@/store/entities/channelmaintain'
class CreateBaseSettingRequest {
    TenancyName: string;
    AuthorizeCategory: number;
    amount: number;
    channelId: number;
    remark: string;
    constructor() {
        this.AuthorizeCategory = 3;
    }
}
@Component
export default class CreateShopeeBaseSetting extends AbpBase {
    @Prop({ type: Boolean, default: false }) value: boolean;
    baseSetting: CreateBaseSettingRequest = new CreateBaseSettingRequest();
    AuthorizeCategoryTypeList = [{ id: 0, title: "个人" }, { id: 1, title: "企业" }, { id: 2, title: "永久" }, { id: 3, title: "体验用户" }];
    Channel: Array<ChannelList> = [];
    ChannelSelect: Array<ChannelList> = [];
    save() {
        (this.$refs.baseSettingForm as any).validate(async (valid: boolean) => {
            if (valid) {
                await this.$store.dispatch({
                    type: 'shopeebasesetting/create',
                    data: this.baseSetting
                });
                (this.$refs.baseSettingForm as any).resetFields();
                this.$emit('save-success');
                this.$emit('input', false);
            }
        })
    }
    cancel() {
        (this.$refs.baseSettingForm as any).resetFields();
        this.$emit('input', false);
    }
    visibleChange(value: boolean) {
        if (!value) {
            this.$emit('input', value);
        }
    }
    baseSettingRule = {
        TenancyName: [{ required: true, message: this.L('FieldIsRequired', undefined, this.L('租户名称')), trigger: 'blur' }],
    }
    async get() {
        await this.$store.dispatch({
            type: 'channel/getAll',
            data: {}
        });
        this.Channel = this.$store.state.channel.list;
        if (this.Channel.length > 0) {
            var _this = this;

            //this.ChannelSelect = this.Channel.filter(function (item) { return item.cargoCategory == _this.$store.state.backmainlandorder.cargoCategory });
            if (this.Channel.length > 0) {
                this.baseSetting.channelId = this.ChannelSelect[0].id;
            }


            //  this.selectuser.id = this.user[0].id;
        }
    }
    created() {
        this.get();

    }
}
